import "jquery-validation";

const commentFormValidation = () => {
	$('.comment-form').validate({
		rules: {
			author: {
				required: true,
				minlength: 2,
			},

			email: {
				required: true,
				email: true,
			},

			comment: {
				required: true,
				minlength: 10,
			},
		},

		messages: {
			author: "Please fill the required field",
			email: "Please enter a valid email address.",
			comment: "Please fill the required field",
		},

		errorPlacement: function(error, element) {
			error.insertBefore(element);
		},

	});
};

export default commentFormValidation;



// WEBPACK FOOTER //
// ./scripts/modules/commentFormValidation.js